"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInquire = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_router_1 = require("react-router");
var useUser_1 = require("../hooks/useUser");
var useInquire = function () {
    var _a = (0, useUser_1.useUser)(), user = _a.user, userLoading = _a.userLoading;
    var _b = (0, react_1.useState)(false), isContact = _b[0], setIsContact = _b[1];
    var _c = (0, react_1.useState)(false), isSend = _c[0], setIsSend = _c[1];
    var _d = (0, react_1.useState)(false), isConfirm = _d[0], setIsConfirm = _d[1];
    var params = (0, react_router_1.useParams)();
    var location = (0, react_router_1.useLocation)();
    var shopCode = params.shop_code || null;
    var initialValues = {
        name: user.name || "",
        email: user.email || "",
        body: "",
        checked: false,
    };
    var validateName = function (value) {
        var error;
        if (!value) {
            error = "氏名を入力してください";
        }
        return error;
    };
    var validateMail = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            if (!value) {
                error = "メールアドレスを入力してください";
            }
            else if (!value.match(/.+@.+\..+/)) {
                error = "メールアドレスの形式を確認してください";
            }
            return [2 /*return*/, error];
        });
    }); };
    var validateBody = function (value) {
        var error;
        if (!value) {
            error = "お問い合わせ内容を入力してください";
        }
        return error;
    };
    var validateIsCheck = function (value) {
        var error;
        if (!value) {
            error = "同意が必要です";
        }
        return error;
    };
    var onSubmit = function (values, actions) {
        // お問い合わせ登録
        axios_1.default
            .post("/api/inquire", {
            name: values.name,
            email: values.email,
            body: values.body,
            shop_code: shopCode,
            url: location.pathname,
        }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then(function () {
            setIsSend(true);
        })
            .catch(function (error) {
            if (error.response.data.error.type === "validate") {
                var customError = [];
                customError["name"] =
                    error.response.data.error.details.name &&
                        error.response.data.error.details.name[0];
                customError["email"] =
                    error.response.data.error.details.email &&
                        error.response.data.error.details.email[0];
                customError["body"] =
                    error.response.data.error.details.zipcode &&
                        error.response.data.error.details.zipcode[0];
                setIsConfirm(false);
                actions.setErrors(customError);
            }
            else {
                console.log("送信エラーです。");
            }
        });
    };
    var onClickSwitchingContact = function () {
        setIsContact(function (prevValue) { return !prevValue; });
        setIsSend(false);
    };
    return {
        user: user,
        userLoading: userLoading,
        initialValues: initialValues,
        validateName: validateName,
        validateMail: validateMail,
        validateBody: validateBody,
        validateIsCheck: validateIsCheck,
        onSubmit: onSubmit,
        isContact: isContact,
        isSend: isSend,
        setIsSend: setIsSend,
        onClickSwitchingContact: onClickSwitchingContact,
        isConfirm: isConfirm,
        setIsConfirm: setIsConfirm,
    };
};
exports.useInquire = useInquire;
